import React from 'react';
import Button from 'components/button/button'

const StatusHelp = () => {
    return (
        <div className="widget box help-container">
            <h3>
                Need a hand with anything?
            </h3>
            <p>
                We're nearly always just a couple minutes away.
            </p>
            <Button 
                level="high"
                size="big"
                label="Chat to us"
                icon="user-circle-o"
                link={'https://hassl.co/contact/'}
            />
        </div>
    )
};

export default StatusHelp;



// WEBPACK FOOTER //
// ./src/sections/status/status-help.jsx